<template>
  <div>
    <h1>Aktualna domyślna prowizja wynosi {{ currentCommission }} %</h1>

    <form class="topform" @submit="handleServiceCreate($event)">
      <div class="input-container">
        <label class="text-center">Prowizja %</label>
        <input
          v-model="commission"
          id="name"
          type="number"
          required
          class="form-control"
          minlength="1"
          min="0"
          max="100"
          step="1"
        />
      </div>

      <button class="buttonm btn btn-outline-dark" type="submit">Zmień</button>
    </form>
    <p v-if="commissionResponse" class="alert">
      {{ commissionResponse }}
    </p>
  </div>
</template>

<script>
export default {
  name: "commission",
  computed: {
    commissionResponse() {
      return this.$store.getters.getCommissionInfo;
    },
    currentCommission() {
      return this.$store.getters.getCurrentCommission;
    },
  },
  created() {
    this.$store.dispatch("getCurrentDefaultCommission", {});
  },

  data: function() {
    return {
      commission: 0,
    };
  },
  methods: {
    handleServiceCreate(e) {
      e.preventDefault();
      const confirmed = confirm(
        `Czy na pewno chcesz zmienić domyślną prowizję na ${this.commission} %`
      );
      if (!confirmed) {
        return;
      }

      this.$store.dispatch("changeDefaultCommission", {
        commission: this.commission / 100,
      });
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
button.btn {
  margin-top: 20px;
}
.topform {
  display: flex;
  flex-direction: column;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
</style>
